module.exports = __webpack_public_path__ + "img/Robe.51613b54.gif";